module.exports = __webpack_public_path__ + "img/thumbnail_IndianElephant_m_normal.49491288.png";